import React from "react";
import { FaBoxOpen, FaTag } from "react-icons/fa";
import './RadioFilters.css';

const RadioBoxCondition = (props) => {
    const {
        useC, 
        setUseC,
        newC, 
        setNewC,
        infoSource
    } = props;

    const handU = (a) => {
        setNewC(false);
        setUseC(a);
        
        if (a) {
            props.handleFilters("Used");
        } else {
            props.handleFilters("");
        }
    };

    const handN = (a) => {
        setNewC(a);
        setUseC(false);
        
        if (a) {
            props.handleFilters("New");
        } else {
            props.handleFilters("");
        }
    };

    const conditionBox = () => {
        return (
            <div className="radio-group-modern">
                {/* New */}
                <div
                //  className="radio-item-modern condition-new"
                 >
                    <input
                        onChange={() => handN(newC ? false : true)}
                        name="Condition"
                        type="radio"
                        className="radio-input-modern"
                        checked={newC}
                        id="condition-new"
                    />
                    <label 
                        className="radio-label-modern" 
                        htmlFor="condition-new"
                    >
                        <span className="radio-circle"></span>
                        <div className="condition-content">
                            <FaTag className="condition-icon new-icon" />
                            <span className="radio-text">
                                {infoSource.language(infoSource, "label", "new")}
                            </span>
                        </div>
                    </label>
                </div>

                {/* Used */}
                <div
                //  className="radio-item-modern condition-used" 
                 style={{ animationDelay: '0.05s' }}>
                    <input
                        onChange={() => handU(useC ? false : true)}
                        name="Condition"
                        type="radio"
                        className="radio-input-modern"
                        checked={useC}
                        id="condition-used"
                    />
                    <label 
                        className="radio-label-modern" 
                        htmlFor="condition-used"
                    >
                        <span className="radio-circle"></span>
                        <div className="condition-content">
                            <FaBoxOpen className="condition-icon used-icon" />
                            <span className="radio-text">
                                {infoSource.language(infoSource, "label", "used")}
                            </span>
                        </div>
                    </label>
                </div>
            </div>
        );
    };

    return conditionBox();
};

export default RadioBoxCondition;